import { render, staticRenderFns } from "./DlgCoinMemo.vue?vue&type=template&id=6e404102&scoped=true"
import script from "./DlgCoinMemo.vue?vue&type=script&lang=js"
export * from "./DlgCoinMemo.vue?vue&type=script&lang=js"
import style0 from "./DlgCoinMemo.vue?vue&type=style&index=0&id=6e404102&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e404102",
  null
  
)

export default component.exports